import { useId as vueUseId } from 'vue';

/**
 * Обёртка над Vue 3.5 `useId()` с опциональным префиксом.
 *
 * Генерирует стабильный идентификатор на всё время жизни компонента.
 * Используется для связки `label ↔ input`, `aria-describedby` и т.п.
 *
 * @param prefix — читаемый префикс, помогает при дебаге и в снапшотах.
 * @returns уникальный id (например `bafsy-input-v-12`).
 */
export function useId(prefix = 'bafsy'): string {
  return `${prefix}-${vueUseId()}`;
}
